












import VueOptions from '@utils/VueOptions'
import Back from '@modules/ui/buttons/Back'
import SuperContainerView from '@superUI/Containers/SuperContainerView'
import PurchaseForm from '@superUI/Forms/PurchaseForm'
import RequestButton from '@components/RequestButton'

settings =
  name: 'PurchaseEdit'
  components: { Back, SuperContainerView, PurchaseForm, RequestButton }

  resources:
    purchase:
      resourceName: 'purchase'
      slug: "purchases/:purchaseId/edit"

  vue:
    computed:
      purchaseId: -> @$route.params.purchaseId

    methods:
      onSave: (item) ->
        @$router.push({ name: 'PurchaseShowPage', params: { purchaseId: @purchaseId } })

      hiSavePurchase: ->
        @saveItem('prime.purchase')

export default VueOptions.vue settings
